export default function InfoCard({ title, children }) {
  return (
    <div className="p-3 bg-white rounded-md shadow-md">
      <h4 className="text-lg font-semibold text-[#04395b] mb-2">{title}</h4>
      <div className="text-sm text-gray-700">{children}</div>
    </div>
  );
}